if (!customElements.get('market-localization-form')) {
  customElements.define('market-localization-form', class MarketLocalizationForm extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const select = this.querySelector('[data-market-language-select]');
      const countryInput = this.querySelector('input[name="country_code"]');
      const localeInput = this.querySelector('input[name="locale_code"]');
      if (!form || !select || !countryInput || !localeInput) return;
      select.addEventListener('change', () => {
        const [country, locale] = select.value.split('|');
        if (!country || !locale) return;
        countryInput.value = country;
        localeInput.value = locale;
        form.submit();
      });
    }
  });
}

if (!customElements.get('localization-suggestion')) {
  customElements.define('localization-suggestion', class LocalizationSuggestion extends HTMLElement {
    connectedCallback() {
      this.currentCountry = this.dataset.currentCountry;
      this.message = this.querySelector('[data-localization-suggestion-message]');
      this.acceptButton = this.querySelector('[data-localization-suggestion-accept]');
      this.dismissButton = this.querySelector('[data-localization-suggestion-dismiss]');
      this.form = this.querySelector('form');
      this.countryInput = this.querySelector('input[name="country_code"]');
      this.localeInput = this.querySelector('input[name="locale_code"]');
      this.marketMap = {
        GB: { locale: 'en', currency: 'GBP £' },
        DE: { locale: 'de', currency: 'EUR €' },
        FR: { locale: 'fr', currency: 'EUR €' },
        NL: { locale: 'en', currency: 'EUR €' },
      };
      if (!this.message || !this.acceptButton || !this.dismissButton || !this.form) return;
      if (window.Shopify && window.Shopify.designMode) return;
      this.loadSuggestion();
    }
    async loadSuggestion() {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const url = new URL(root + 'browsing_context_suggestions.json', window.location.origin);
        url.searchParams.set('country[enabled]', 'true');
        url.searchParams.set('country[exclude]', this.currentCountry);
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        if (!response.ok) return;
        const data = await response.json();
        const country = data.suggestions?.[0]?.parts?.country;
        if (!country || !this.marketMap[country.handle] || country.handle === this.currentCountry) return;
        const storageKey = `bonafinds-localization-dismissed-${country.handle}`;
        if (sessionStorage.getItem(storageKey) === 'true') return;
        this.suggestedCountry = country.handle;
        this.storageKey = storageKey;
        const market = this.marketMap[country.handle];
        this.message.textContent = this.dataset.promptTemplate.replace('[country]', country.name).replace('[currency]', market.currency);
        this.acceptButton.addEventListener('click', () => this.acceptSuggestion());
        this.dismissButton.addEventListener('click', () => this.dismissSuggestion());
        this.hidden = false;
      } catch (error) {
        this.hidden = true;
      }
    }
    acceptSuggestion() {
      const market = this.marketMap[this.suggestedCountry];
      if (!market || !this.countryInput || !this.localeInput) return;
      this.countryInput.value = this.suggestedCountry;
      this.localeInput.value = market.locale;
      this.form.submit();
    }
    dismissSuggestion() {
      if (this.storageKey) sessionStorage.setItem(this.storageKey, 'true');
      this.hidden = true;
    }
  });
}
